import { fetchMedia } from './media.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchMarketStats = async (type) => {
  const results = await Promise.all([fetchMedia('market_stats', `na_${type}.json`), fetchMedia('market_stats', `eu_${type}.json`)]);

  return {
    na: results[0],
    eu: results[1],
  };
};
